import { actionCreatorFactory } from 'typescript-fsa';
import { BugReport, BugReportStatus, SelfEvalResponse, SelfEvalStatus } from '../../types/admin';

const actionCreator = actionCreatorFactory('admin-ui');

export const launchEvaluateSelfEvalResponse = actionCreator(
  'ADMIN_EVALUTE_SELF_RESPONSES'
);
export const loadMoreSelfEvalResponse = actionCreator('ADMIN_LOAD_MORE_SELF_EVAL');
export const loadedSelfEvalResponses = actionCreator<SelfEvalResponse[]>(
  'ADMIN_LOADED_SELF_EVAL'
);
export const updateSelfEvalResponse = actionCreator<{id: string, status: SelfEvalStatus}>(
  'ADMIN_UPDATE_SELF_EVAL'
);

export const launchBugReport = actionCreator('ADMIN_BUG_REPORT');
export const loadedBugReports = actionCreator<BugReport[]>('ADMIN_LOADED_BUG_REPORTS');
export const updateBugReport = actionCreator<{id: string, status: BugReportStatus}>(
  'ADMIN_UPDATE_BUG_REPORT'
);

export const goToTeacherHomeFromAdmin = actionCreator('ADMIN_GOTO_TEACHER');